/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationFilter {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationFilter.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationFilter>): CurrencyExchangeConfigurationFilter {
        let obj = Object.assign(new CurrencyExchangeConfigurationFilter(), model);
        CurrencyExchangeConfigurationFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationFilter>): CurrencyExchangeConfigurationFilter {
        if (!model) return null;
        return CurrencyExchangeConfigurationFilter.newInstance(<CurrencyExchangeConfigurationFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationFilter) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationFilter): boolean {
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    tenant_ids: Array<string>;

    /**
     * Text filter used to search names
     */
    text_filter: string;

    /**
     * Query operator
     */
    query: models.QueryOperator;

}
